import React from 'react';
import Button from '@avtopro/button';
import homeResx from 'Resx/Home/Home.resx';

const BannerSuccess = ({ onClose }): JSX.Element => {
    return (
        <>
            <div className="modwin__caption">
                {homeResx.BannerStartSalesModalSuccessTitle}
            </div>
            <div className="modwin__sub-caption">
                {homeResx.BannerStartSalesModalSuccessSubTitle}
            </div>
            <div className="pro-form__footer pro-form__footer--mirror">
                <div className="pro-form__control">
                    <Button
                        onClick={() => onClose()}
                        theme="prime"
                        uppercase
                        framed
                    >
                        {homeResx.BannerStartSalesModalSuccessBtnText}
                    </Button>
                </div>
            </div>
        </>
    );
};

export default BannerSuccess;
